import moment from "moment";
import { Button } from "risa-oasis-ui_v2";

interface MnFooterProps {
  updatedAt: string | null;
  updatedBy: string | null;
  hasChanges: boolean;
  isSaving: boolean;
  onSave: () => void;
}

const MnFooter = ({
  updatedAt,
  updatedBy,
  hasChanges,
  isSaving,
  onSave,
}: MnFooterProps) => (
  <div className="flex flex-shrink-0 items-center justify-between border-t border-primaryGray-16 pt-3">
    <div className="text-tiny text-primaryGray-1">
      {updatedAt && (
        <>
          Updated at:{" "}
          <span className="font-semibold">
            {moment(updatedAt).format("DD MMM YYYY HH:mm")}
          </span>{" "}
          by <span className="font-semibold">{updatedBy || "N/A"}</span>
        </>
      )}
    </div>
    <Button
      buttonType="primary"
      size="medium"
      disabled={!hasChanges || isSaving}
      onClick={onSave}
    >
      {isSaving ? "Saving..." : "Save Changes"}
    </Button>
  </div>
);

export default MnFooter;
